import { Component, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { Observable } from 'rxjs';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { PositionService } from '../position.service';
import { CustomerService } from '../customer.service';
import { IDtoPositionList } from 'app/shared/models/position/dto-position-list.model';
import { IUser } from 'app/shared/models/user.model';
import { StorageService } from 'app/shared/services/storage.service';

@Component({
    selector: 'app-list-positions',
    styleUrls: ['./list-positions.style.scss'],
    templateUrl: './list-positions.template.html'
})
export class ListPositionsComponent implements OnDestroy, OnInit {
    /**Formularios */
    private formFilter: FormGroup;
    /**Catalogos */
    private catalogPositionStatus: Observable<IDtoCatalog[]>;
    private catalogCustomers: Observable<IDtoCatalog[]>;
    /**Variables */
    private now: number;
    /**Listas */
    private requisitions: IDtoRequisition[];
    private town: string;
    private state: string;
    private search: string;
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tablePositions: DatatableComponent;
    /**Slim-control */
    optsSlim: ISlimScrollOptions;
    scrollEvents: EventEmitter<SlimScrollEvent>;
    private profile: string;
    private positionList: IDtoPositionList[];
    private positionListTemp: IDtoPositionList[];
    private user: IUser;
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private router: Router
        , private route: ActivatedRoute
        , private spinner: NgxSpinnerService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private positionService: PositionService
        , private customerService: CustomerService
        , private storageService: StorageService) {
        this.user = this.securityService.getUserDataStorage();
        this.profile = this.securityService.getProfileStorage('Jobs');
        this.optsSlim = configGeneral.getConfigSlimScroll();
        this.initializeFormFilter();
    }
    ngOnInit(): void {
        this.scrollEvents = new EventEmitter<SlimScrollEvent>();
        this.now = Date.now();
        if (this.configurationService.isReady) {
            //this.spinner.show();
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                //this.spinner.show();
                this.getCatalogs();
            });
        }
        this.initFilters();
    }
    ngOnDestroy(): void {
    }
    private initFilters(): void {
        const customer = this.storageService.retrieve('jobs.customer');
        if (customer != null) {
          this.formFilter.get('customerId').patchValue(+customer);
        }
        const search = this.storageService.retrieve('jobs.search');
        if (search != undefined) {
          this.search = search;
        }
        if (customer != null) {
            this.getPositionsByFilter();
        }
    }
    private initializeFormFilter() {
        this.formFilter = this.formBuilder.group({
            customerId: [null]
        });
    }
    private navigateTo(row: IDtoPositionList): void {
        const customerId = +this.formFilter.value.customerId;
        this.storageService.store('jobs.customer', customerId);
        this.storageService.store('jobs.search', this.search);
        this.router.navigate(['/positions/create',
            { id: row.id, action: 'update' }], { relativeTo: this.route });
    }
    private getCatalogs(): void {
        if (this.profile == 'Ejecutivo') {
            this.catalogCustomers = this.customerService.getCatalogCustomersByExecutive(this.user.userId);
        } else {
            this.catalogCustomers = this.customerService.getCatalogCustomers();
        }
    }
    private getPositionsByFilter(): void {
        const customerId = +this.formFilter.value.customerId;
        if (customerId == 0) {
            this.configGeneral.newToast('Validación', 'Seleccione un cliente para poder continuar', 'warning');
            return;
        }
        this.spinner.show();
        this.positionService.getPositionsByFilter(customerId).subscribe((res) => {
            this.positionList = res.data as IDtoPositionList[];
            this.positionListTemp = this.positionList;
            if (this.search != undefined) {
                this.updateFilter();
            }
            this.spinner.hide();
        });
    }

    private updateFilter() {
        if (this.search === undefined) {
            return;
        }

        const val = this.search.toLowerCase();
        const temp = this.positionListTemp.filter((x: any) => x.productName.toLowerCase().startsWith(val)
            || x.tradename.toLowerCase().startsWith(val) 
            || x.customerName.toLowerCase().startsWith(val)
            || x.positionStatusName.toLowerCase().startsWith(val)
            || x.isrTypedName.toLowerCase().startsWith(val)
            || x.codeNom.toLowerCase().startsWith(val));
     
        this.positionList = temp;
        this.tablePositions.offset = 0;
    }
}
